import React from 'react';
import { useHistory } from 'react-router-dom';
import { Action } from '../Card';
import { PagesFragment } from '../../generated/graphql';
import CustomItemCard from './CustomItemCard';
import { newItemsRoute } from '../../helpers/routes';
import GuidanceItemCard from './GuidanceItemCard';

import styles from './index.scss';
import RoomBlockAndTransient from '../PageCard/RoomBlockAndTransient';

interface Props {
  page?: PagesFragment;
}

const CUSTOM_PAGE = 'CustomPage';

const PageGuidance: React.FC<Props> = ({ page }) => {
  const history = useHistory();

  if (!page || page?.pageItemGuidances?.length === 0) {
    return null;
  }

  const firstTwoPageGuidanceItems = page?.pageItemGuidances?.slice(0, 2) || [];
  const rest = page?.pageItemGuidances?.slice(2) || [];
  const pageItemTypes = rest
    .map(item => item.type || '')
    .filter(type => {
      return !!type;
    });

  return (
    <>
      {page?.type === CUSTOM_PAGE ? (
        <Action
          className={styles.addContent}
          iconName="add_circle"
          onClick={() => history.push(newItemsRoute(page.id))}
          data-testid={`custom-page-guidance-${page.id}`}
        >
          Add Content
        </Action>
      ) : (
        <>
          <div data-testid={`${page.type}-guidance-card`} className={styles.pageGuidanceItemsContainer}>
            {firstTwoPageGuidanceItems.map((guidance, index) => {
              return <GuidanceItemCard key={index} pageId={page.id} guidance={guidance} />;
            })}
            {<CustomItemCard pageId={page.id} pageItemTypes={pageItemTypes} />}
          </div>
          {!!(page.type === 'TravelPage') && (
            <div className={styles.hotelPlanerContainer}>
              <RoomBlockAndTransient page={page} />
            </div>
          )}
        </>
      )}
    </>
  );
};
export default PageGuidance;
